export async function ajaxAction(
	$,
	ajaxurl,
	nonce,
	action = '',
	args = {},
	method = 'get'
) {
	if (!action) {
		return false;
	}

	try {
		return await $.ajax({
			type: method,
			url: ajaxurl,
			data: {
				action,
				args,
				security: nonce,
			},
		});
	} catch (error) {
		console.error('AJAX ERROR:', error);
		return false;
	}
}
